import { render, staticRenderFns } from "./ReservationInsights.vue?vue&type=template&id=1f6fcd84&scoped=true"
import script from "./ReservationInsights.vue?vue&type=script&lang=js"
export * from "./ReservationInsights.vue?vue&type=script&lang=js"
import style0 from "./ReservationInsights.vue?vue&type=style&index=0&id=1f6fcd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6fcd84",
  null
  
)

export default component.exports